export enum LoginModalStep {
  LOGIN = "login",
  SIGNUP = "signup",
  EMAIL_CONFIRM = "emailConfirm",
  CODE_CONFIRM = "codeConfirm",
  AGE_VERIFICATION = "ageVerification",
  FORGOT = "forgot",
  BACK_FROM_CONFIRM = "backFromConfirm",
}
